var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseSoftIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.547 8 4.828-4.781.984-.985c.141-.14.141-.375 0-.562L14.33.64C14.14.5 13.905.5 13.765.64L8 6.453 2.187.641C2.047.5 1.813.5 1.625.64L.594 1.67c-.14.188-.14.423 0 .563L6.406 8 .594 13.813c-.14.14-.14.374 0 .562l1.031 1.031c.188.14.422.14.563 0L8 9.594l4.781 4.828.985.984c.14.14.375.14.562 0l1.031-1.031c.141-.188.141-.422 0-.563L9.547 8Z",
    fill: "#9496AC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseSoftIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close-soft-icon.9d140a95778e7182aa8b09c3ef3291c7.svg";